module.exports = __webpack_public_path__ + "media/images/result_sets/hero_mobile-8802d3c6838d8f7b9a4739eb9b21f58f.svg";